import { render } from "./ExamQuestion.vue?vue&type=template&id=13e8f02a&scoped=true"
import script from "./ExamQuestion.vue?vue&type=script&lang=ts"
export * from "./ExamQuestion.vue?vue&type=script&lang=ts"

import "./ExamQuestion.vue?vue&type=style&index=0&id=13e8f02a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13e8f02a"

export default script